import { type ReactNode } from 'react';
import { Modal } from '@/components/ui/modal';
import { Fade } from '@/components/ui/fade';
import { useCreatorDetail } from '../hooks/use-creator-detail';
import { CreatorDetailSkeleton } from './creator-detail-skeleton';
import { CreatorDetailContent } from './creator-detail-content';

type Props = { leadId: string | null; onClose: () => void };

function Content({
  id,
  onClose,
}: {
  id: string;
  onClose: () => void;
}): ReactNode {
  const { data: creator, isLoading } = useCreatorDetail(id);
  const state = isLoading || !creator ? 'skeleton' : 'loaded';
  return (
    <Fade activeKey={state}>
      {state === 'skeleton' ? (
        <CreatorDetailSkeleton />
      ) : (
        <CreatorDetailContent creator={creator!} onClose={onClose} />
      )}
    </Fade>
  );
}

export function CreatorDetailModal({ leadId, onClose }: Props): ReactNode {
  return (
    <Modal open={!!leadId} onClose={onClose} title="Perfil">
      {leadId && <Content id={leadId} onClose={onClose} />}
    </Modal>
  );
}
